<template>
    <div class="box">
        <div>
            <label class="fontawesome-checkbox is-size-5">
                <input v-model="isChecked" type="checkbox" />
                <span>{{ sourceEvent.fullName }}</span>
            </label>
        </div>
        <div class="is-size-6 mt-1">
            <p>
                {{
                    translate("notification_center.receivers_summary", false, [
                        sourceEvent.uniqueReceivers.users,
                        sourceEvent.uniqueReceivers.emails,
                        sourceEvent.uniqueReceivers.phones,
                    ])
                }}
            </p>
            <p>
                {{ translate("notification_center.registered_competitors") }}
                {{ sourceEvent.totalRegistrations }}
            </p>
            <p>
                {{ translate("notification_center.confirmed_payments") }}
                {{ sourceEvent.confirmedPayments }}
            </p>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import translatorMixin from "../../Common/translatorMixin";

    export default {
        name: "source-event",
        mixins: [translatorMixin],
        props: ["sourceEvent"],
        data() {
            return {
                isChecked: false,
            };
        },
        computed: {
            ...mapGetters("choosingSourceEvents", ["isSelected"]),
        },
        watch: {
            isChecked() {
                if (this.isChecked) {
                    this.$store.dispatch("choosingSourceEvents/chooseEvent", this.sourceEvent.id);
                } else {
                    this.$store.dispatch("choosingSourceEvents/removeEvent", this.sourceEvent.id);
                }
            },
        },
        mounted() {
            if (this.isSelected(this.sourceEvent.id)) {
                this.isChecked = true;
            }
        },
    };
</script>

<style scoped></style>
